import React from "react";

//Custom Components
import PrijevozniciPage from "UI/AppPage/PrijevozniciPage";
import ResponsiveBox from "UI/Box/ResponsiveBox";
import KomitentiTable from "Views/Prijevoznici/Komitenti/KomitentiTable";

const PrijevozniciKomitentiPage = React.memo((props) => {
  return (
    <PrijevozniciPage>
      <ResponsiveBox fillHeight>
        <KomitentiTable />
      </ResponsiveBox>
    </PrijevozniciPage>
  );
});

export default PrijevozniciKomitentiPage;
